import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Activity } from 'lucide-react';

declare global {
  interface Window {
    GC?: {
      team: {
        schedule: { init: (config: any) => void };
      };
    };
  }
}

const LiveScores = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://widgets.gc.com/static/js/sdk.v1.js';
    script.async = true;
    script.onload = () => {
      if (window.GC) {
        window.GC.team.schedule.init({
          target: "#gc-schedule-widget-kjhh",
          widgetId: "40682427-9650-45e1-a5ab-1f398e38dc87",
          maxVerticalGamesVisible: 4,
        });
      }
    };
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-[#111111]">
      <Navbar />
      
      <main className="flex-1 mt-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center gap-4 mb-8">
            <Activity className="w-8 h-8 text-cardinal" />
            <h1 className="text-4xl font-bold text-white">Live Scores & Standings</h1>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {/* Live Scores Widget */}
            <div className="bg-[#222222] p-8 rounded-xl shadow-lg border border-white/5">
              <div className="flex items-center gap-3 mb-6">
                <Activity className="w-6 h-6 text-cardinal" />
                <h2 className="text-2xl font-bold text-white">Live Game Updates</h2>
              </div>
              <div className="bg-[#1A1A1A] rounded-lg overflow-hidden min-h-[500px]">
                <div id="gc-schedule-widget-kjhh"></div>
              </div>
            </div>

            {/* League Standings Image */}
            <div className="bg-[#222222] p-8 rounded-xl shadow-lg border border-white/5">
              <div className="flex items-center gap-3 mb-6">
                <Activity className="w-6 h-6 text-cardinal" />
                <h2 className="text-2xl font-bold text-white">Join Our GameChanger!</h2>
              </div>
              <div className="bg-[#1A1A1A] rounded-lg overflow-hidden">
                <img 
                  src="https://i.postimg.cc/hj0vHZy7/1a8974ca-d34d-4409-b1e9-25997a0cbc93.jpg"
                  alt="League Standings"
                  className="w-full h-auto"
                />
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default LiveScores;